import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable no-plusplus */
// PIN utils for validating PIN code patterns
import { EMPTY_PIN_ENTRY_FIELD } from '../types';
const PIN_REGEX = /^\d{4}$/; // 1234
const VALID_SINGLE_DIGIT_REGEX = new RegExp('0|1|2|3|4|5|6|7|8|9');
const INVALID_ADJACENT_CIPHERS_REGEX = /(012|123|234|345|456|567|678|789|890|901|098|987|876|765|654|543|432|321|210|109)/;
export const isPinCodePattern = pin => {
  if (pin === null) {
    return false;
  }
  if (pin.length !== 4) {
    return false;
  }
  return PIN_REGEX.test(pin);
};
const hasRecurringCharactersBeyondThreshold = pin => {
  const frequencyMap = {};

  // Count the frequency of each character in the pin
  for (const char of pin) {
    if (frequencyMap[char]) {
      frequencyMap[char]++;
    } else {
      frequencyMap[char] = 1;
    }
  }

  // Check if any character has a frequency greater than 2
  for (const frequency of Object.values(frequencyMap)) {
    if (frequency > 2) {
      return true;
    }
  }
  return false;
};
export const hasValidRecurringCharacters = pin => !hasRecurringCharactersBeyondThreshold(pin);
export const hasValidAdjacentCiphers = pin => !INVALID_ADJACENT_CIPHERS_REGEX.test(pin.toString());
export const isValidPinEntryLength = pinEntry => pinEntry.length === 4;
export const isPinEntryFieldsFourDigits = pinEntry => pinEntry.filter(pinCodeEntry => typeof pinCodeEntry === 'undefined' || pinCodeEntry === EMPTY_PIN_ENTRY_FIELD).length === 0;
export const isValidPin = pinEntry => {
  const pinString = pinEntry.join('');
  if (!isPinCodePattern(pinString)) {
    return false;
  }
  return hasValidRecurringCharacters(pinString) && hasValidAdjacentCiphers(pinString);
};

// Parsing number on input
const isValidSingleDigit = value => VALID_SINGLE_DIGIT_REGEX.test(value);
const isValidPinEntryField = value => {
  if (typeof value === 'undefined' || value === EMPTY_PIN_ENTRY_FIELD) {
    return true;
  }
  return isValidSingleDigit(value);
};
export const parseNewPinEntryInput = inputValue => {
  if (isValidPinEntryField(inputValue)) {
    return inputValue;
  }
  return EMPTY_PIN_ENTRY_FIELD;
};